import {
  type EventTypes,
  ListEventTypes,
} from '@/domains/traffic-monitoring/constants/listEvent.constant';
import { useColorStore } from '@/store/colorStore';

interface TimelineItemType {
  id: number;
  title: string;
  subtitle?: string;
  date: string;
  status?: EventTypes;
  statusLabel?: string;
  icon?: string;
}

interface Props {
  item: TimelineItemType;
  isLast: boolean;
}

const TimelineVertical = ({ item, isLast }: Props) => {
  const { NEWCOLOR } = useColorStore();

  const status = item.status && ListEventTypes[item.status] ? ListEventTypes[item.status] : null;

  return (
    <div className="relative flex gap-3 pb-8">
      {!isLast && <div className="absolute left-[18px] top-10 h-full w-[2px] bg-gray-200" />}

      {/* <div className="relative z-10 flex h-9 w-9 items-center justify-center rounded-full bg-blue-600 text-white">
        {item.icon}
      </div> */}
      <img src={item.icon} alt="icon" className="h-9 w-9" />

      <div className="flex-1">
        <div className="flex items-start justify-between gap-2">
          <div className="flex flex-col gap-0">
            <span className="title2 text-text-grey">{item.subtitle}</span>

            <span className="title1medium">{item.title}</span>

            <span className="title2 text-text-grey">{item.date}</span>
          </div>

          {status && (
            <span
              className="rounded-full px-3 py-1 title2 text-white text-center uppercase"
              style={{
                backgroundColor: NEWCOLOR[status.color],
              }}
            >
              {item.statusLabel ?? item.status?.replace(/_/g, ' ')}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimelineVertical;
